import axios from "axios";

import { ApiResult } from "../models/ApiResult";
import { OtpResult } from "../models/OtpResult";

const mfaApiUrl = import.meta.env.RAM_MFA_API_URL;
const heartbeatUrl = import.meta.env.RAM_HEARTBEAT_URL;
const localServiceUrl = import.meta.env.RAM_LOCALSERVICE_URL;

const sendOtpEndpoint = "/SendOTP";
const validateOtpEndpoint = "/ValidateOTP";

export const AuthAPI = axios.create({
  baseURL: mfaApiUrl,
});
export const LocalAPI = axios.create({
  baseURL: localServiceUrl,
  timeout: 1000,
});

export const Services = axios.create({
  baseURL: heartbeatUrl,
});

export default {
  sendOtp(email: string) {
    return AuthAPI.get<ApiResult<OtpResult>>(`${sendOtpEndpoint}/${email}`);
  },
  validateOtp(email: string, otp: string) {
    return AuthAPI.get<ApiResult<string>>(
      `${validateOtpEndpoint}/${email}/${otp}`,
    );
  },
  triggerHeartbeat() {
    return LocalAPI.post<ApiResult<any>>(`/trigger`, {});
  },
  getSystemStatus() {
    return LocalAPI.get<ApiResult<any>>(`/status`);
  },
  sentDataService(data: any) {
    return Services.post<ApiResult<any>>(`/fingerprint`, data);
  },
};
